
import { Component, Vue } from "vue-property-decorator";
import { Project } from "@/interfaces";
import {
  readProjects,
  readHasAdminAccess,
  readOneProject,
} from "@/store/main/getters";
import { dispatchGetProjects, dispatchGetProject } from "@/store/main/actions";

@Component
export default class ViewProject extends Vue {
  public loading = true;

  get projects() {
    return readProjects(this.$store);
  }

  get project() {
    return readOneProject(this.$store)(+this.$router.currentRoute.params.id);
  }

  public rotates: number[] = [];

  public async mounted() {
    const id = +this.$router.currentRoute.params.id;
    const own = !readHasAdminAccess(this.$store); // if admin set own to false

    if (this.projects.length == 0) {
      await Promise.allSettled([dispatchGetProject(this.$store, { id: id })]);
    }

    this.loading = false;

    let deg = 270;
    this.project?.requests.map((request) => {
      this.rotates.push(deg);
      deg = deg + request.state * 3.6;
    });
  }

  public getHashrate(hashrate: number, currency_id: number) {
    return 0;
  }

  public getColor(index) {
    const mod = index % 10;
    switch (mod) {
      case 0:
        return "#F44336";
      case 1:
        return "#E91E63";
      case 2:
        return "#2196F3";
      case 3:
        return "#FF9800";
      case 4:
        return "#9C27B0";
      case 5:
        return "#4CAF50";
      case 6:
        return "#3F51B5";
      case 7:
        return "#607D8B";
      case 8:
        return "#009688";
      case 9:
        return "#673AB7";
    }
  }
}
